module.exports = __webpack_public_path__ + "img/2.a9499c77.jpg";